// extracted by mini-css-extract-plugin
export default {"container":"PhotographerInstructions-module--container--979c8","buttons":"PhotographerInstructions-module--buttons--fd35a","inner":"PhotographerInstructions-module--inner--96fb1"};